<script lang="ts">
    import dayjs from 'dayjs'

    export let position: 'relative' | 'fixed' = 'fixed'
    export let createdAt: Date
    export let company

    function getFooterAddress() {
        let s = ''
        if (company?.street) {
            s += company.street + ', ' + company.addressNumber
            if (company.addressComplement) {
                s += ', ' + company.addressComplement
            }
            s += ' - ' + company.neighborhood
            s += ' - ' + company.city + ' / ' + company.state
            s += ' / CEP ' + company.zipCode
        }
        return s
    }

    function getFooterContact() {
        let s = ''
        if (company?.phone) {
            s += 'Telefone ' + window.api.utils.utils.phoneFriendly(company.phone)
        }
        if (company?.email) {
            if (s) s += ' | '
            s += 'E-mail ' + company.email.toLowerCase()
        }
        return s
    }
</script>

<div class="footer_print" style="position:{position};">
    <div class="footer_print_company">
        {company?.companyName || ''}
    </div>
    <div class="footer_print_address">
        {getFooterAddress()}
    </div>
    <div class="footer_print_contact">
        {getFooterContact()}
    </div>
    <div class="footer_print_date">
        Documento emitido em {dayjs(createdAt).format('DD/MM/YYYY HH:mm:ss')}
    </div>
</div>

<style>
    .footer_print {
        text-align: center;
        bottom: 0px;
        flex-grow: 1;
        height: 100px;
        width: 100%;
        font-size: 15px;
        background-color: white;
        border-radius: 0px 0px 8px 8px;
    }

    .footer_print_date {
        font-size: 13px;
    }

    @media (max-width: 900px) {
        .footer_print {
            font-size: 13px;
        }
    }
</style>
